import { FormControlLabel, AccordionSummary, Accordion, AccordionDetails, Typography, Grid } from '@mui/material';
import React from 'react';
import { WO2Checkbox, WO2ToggleSwitch } from 'src/common';
import DateRangePicker from 'src/common/components/DateRangePicker';
import { BaseReportComponentProps, MdaReportTypes } from '../../store/types';
import { DateRange } from 'src/store';
import { ActionCreatorWithoutPayload, ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { ExpandMore } from '@mui/icons-material';

export interface UnrealisedNonCGTGainsAndLossesProps extends BaseReportComponentProps {
  setAsAtDateUnrealisedNonCGTParameter: ActionCreatorWithPayload<DateRange, string>;
  setUnrealisedNonCGTSelectedParameter: ActionCreatorWithPayload<boolean, string>;
  setUnrealisedNonCgtExcludeFxParameter: ActionCreatorWithPayload<boolean, string>;
  setUnrealisedNonCgtShowCostBaseAdjustmentsParameter: ActionCreatorWithPayload<boolean, string>;
  expandUnrealisedNonCgt: ActionCreatorWithoutPayload<string>;
}

export const UnrealisedNonCGTGainsAndLosses = ({
  parameters,
  setUnrealisedNonCGTSelectedParameter,
  setAsAtDateUnrealisedNonCGTParameter,
  setUnrealisedNonCgtExcludeFxParameter,
  setUnrealisedNonCgtShowCostBaseAdjustmentsParameter,
  expandUnrealisedNonCgt,
  createReportSortRequest,
}: UnrealisedNonCGTGainsAndLossesProps): JSX.Element => {
  const handleClickSelect = () => {
    setUnrealisedNonCGTSelectedParameter(!parameters.selectedReports.unrealisedNonCGT.selected);
    createReportSortRequest(
      !parameters.selectedReports?.unrealisedNonCGT.selected,
      MdaReportTypes.UnrealisedNonCgt.id,
      MdaReportTypes.UnrealisedNonCgt.displayName
    );
  };

  const handleClickDate = (dates: DateRange) => {
    setAsAtDateUnrealisedNonCGTParameter(dates);
  };

  return (
    <Accordion onChange={expandUnrealisedNonCgt} expanded={parameters.selectedReports?.unrealisedNonCGT.expanded || false} elevation={0}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FormControlLabel
          sx={{ flex: 1 }}
          aria-label="Acknowledge"
          onClick={(event) => event.stopPropagation()}
          onFocus={(event) => event.stopPropagation()}
          control={
            <WO2Checkbox color="primary" checked={parameters.selectedReports?.unrealisedNonCGT.selected} onChangeHandler={handleClickSelect} />
          }
          label="Unrealised Non-CGT Gains and Losses"
        />
        <div onClick={(e) => e.stopPropagation()}>
          <DateRangePicker
            sx={{ minWidth: 194 }}
            dateRange={{
              dateFrom: '',
              dateTo: parameters?.selectedReports.unrealisedNonCGT?.asAtDate,
              dateRangeType: parameters?.selectedReports.unrealisedNonCGT?.asAtDateType,
            }}
            dateOnlyLabel="As at"
            setDateRange={handleClickDate}
            isDateOnly
          />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container alignItems="center" spacing={2}>
          <Grid container item xs={4} alignItems="center">
            <WO2ToggleSwitch
              checked={parameters.selectedReports.unrealisedNonCGT.excludeFxGainsLosses}
              onChange={(_, checked: boolean) => {
                setUnrealisedNonCgtExcludeFxParameter(checked);
              }}
              color="primary"
              name="hidingOptions"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            <Typography variant="h4">Exclude FX Gains/Losses</Typography>
          </Grid>
          <Grid container item xs={4} alignItems="center">
            <WO2ToggleSwitch
              checked={parameters.selectedReports.unrealisedNonCGT.showCostBaseAdjustments}
              onChange={(_, checked: boolean) => {
                setUnrealisedNonCgtShowCostBaseAdjustmentsParameter(checked);
              }}
              color="primary"
              name="hidingOptions"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            <Typography variant="h4">Show Cost Base Adjustments</Typography>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
